"use strict";
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Editor_1 = require("./components/Editor");
exports.Editor = Editor_1.Editor;



//////////////////
// WEBPACK FOOTER
// ./~/@tinymce/tinymce-react/lib/cjs/main/ts/index.js
// module id = 453
// module chunks = 0